var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoAzulOutros(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.999,
    height: 72,
    viewBox: "0 0 71.999 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16946",
    "data-name": "Grupo 16946",
    transform: "translate(-1070.002 -367.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclus\\xE3o_10",
    "data-name": "Exclus\\xE3o 10",
    d: "M14307-2488a35.77,35.77,0,0,1-14.013-2.829,35.878,35.878,0,0,1-11.443-7.716,35.891,35.891,0,0,1-7.714-11.443A35.783,35.783,0,0,1,14271-2524a35.787,35.787,0,0,1,2.829-14.014,35.886,35.886,0,0,1,7.714-11.443,35.869,35.869,0,0,1,11.443-7.715A35.774,35.774,0,0,1,14307-2560a35.77,35.77,0,0,1,14.012,2.829,35.886,35.886,0,0,1,11.444,7.715,35.891,35.891,0,0,1,7.715,11.443A35.788,35.788,0,0,1,14343-2524a35.783,35.783,0,0,1-2.829,14.012,35.9,35.9,0,0,1-7.715,11.443,35.9,35.9,0,0,1-11.444,7.716A35.773,35.773,0,0,1,14307-2488Zm11.152-40.834a4.564,4.564,0,0,0-4.561,4.557,4.566,4.566,0,0,0,4.561,4.561,4.564,4.564,0,0,0,4.557-4.561A4.562,4.562,0,0,0,14318.153-2528.833Zm-11.224,0a4.563,4.563,0,0,0-4.558,4.557,4.565,4.565,0,0,0,4.558,4.561,4.566,4.566,0,0,0,4.561-4.561A4.564,4.564,0,0,0,14306.93-2528.833Zm-11.221,0a4.564,4.564,0,0,0-4.561,4.557,4.566,4.566,0,0,0,4.561,4.561,4.566,4.566,0,0,0,4.562-4.561A4.564,4.564,0,0,0,14295.709-2528.833Zm22.444,6.907a2.353,2.353,0,0,1-2.351-2.35,2.352,2.352,0,0,1,2.351-2.347,2.352,2.352,0,0,1,2.351,2.347A2.353,2.353,0,0,1,14318.153-2521.926Zm-11.224,0a2.351,2.351,0,0,1-2.347-2.35,2.35,2.35,0,0,1,2.347-2.347,2.352,2.352,0,0,1,2.351,2.347A2.353,2.353,0,0,1,14306.93-2521.926Zm-11.221,0a2.352,2.352,0,0,1-2.35-2.35,2.351,2.351,0,0,1,2.35-2.347,2.352,2.352,0,0,1,2.351,2.347A2.353,2.353,0,0,1,14295.709-2521.926Z",
    transform: "translate(-13201 2927)",
    fill: "#4663ab"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAzulOutros);
export default __webpack_public_path__ + "static/media/ico-azul-outros.d0beb7d67d1940b4a94c316c3948b79b.svg";
export { ForwardRef as ReactComponent };